import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'customKeys', pure: false})
export class CustomKeysPipe implements PipeTransform{
	transform(value: any, args: any[] = null): any {
		return Object.keys(value);
	}
}
